<template>
  <v-dialog v-model="dialog" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" v-if="!edit">Ajouter Activité</v-btn>
      <v-btn small v-bind="attrs" v-on="on" icon v-if="edit">
        <v-icon>mdi-pencil-outline</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>{{ titre }}</v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="activiteForm" @submit.prevent="saveForm">
            <div>
              <div v-if="$v.nomActivite.$dirty">
                <div class="error" v-if="!$v.nomActivite.required">
                  Ce champ est requis
                </div>
              </div>
              <v-text-field v-model="$v.nomActivite.$model" label="Nom"></v-text-field>
            </div>
            <div v-if="edit">
              <div v-if="$v.ordre.$dirty">
                <div class="error" v-if="!$v.ordre.required">
                  Ce champ est requis
                </div>
                <div class="error" v-if="!$v.ordre.numeric">
                  Veuillez entrer une valeur numérique
                </div>
              </div>
              <v-text-field v-model="$v.ordre.$model" label="Ordre" type="number" min=1></v-text-field>
            </div>
            <div>
              <div v-if="$v.dateDebut.$dirty">
                <div class="error" v-if="!$v.dateDebut.required">
                  Ce champ est requis
                </div>
              </div>
              <DatePickerComponent v-on:dateSaved="saveDateDebut" v-bind:previousDate="dateDebut" label="Date de début">
              </DatePickerComponent>
            </div>
            <div>
              <div v-if="$v.dateFin.$dirty">
                <div class="error" v-if="!$v.dateFin.required">
                  Ce champ est requis
                </div>
              </div>
              <DatePickerComponent v-on:dateSaved="saveDateFin" v-bind:previousDate="dateFin" v-bind:minDate="dateDebut"
                label="Date de fin"></DatePickerComponent>
            </div>
            <div>
              <div v-if="$v.etatEcheancier.$dirty">
                <div class="error" v-if="!$v.etatEcheancier.required">
                  Ce champ est requis
                </div>
              </div>
              <v-select :items="etatEcheancierItems" label="Etat échéancier" v-model="$v.etatEcheancier.$model">
              </v-select>
            </div>
            <div>
              <div v-if="$v.avancement.$dirty">
                <div class="error" v-if="!$v.avancement.required">
                  Ce champ est requis
                </div>
              </div>
              <v-select v-model="$v.avancement.$model" :items="avancementItems" label="Avancement"></v-select>
            </div>
            <div>
              <div v-if="$v.responsable.$dirty">
                <div class="error" v-if="!$v.responsable.required">
                  Ce champ est requis
                </div>
                <div class="error" v-if="!$v.responsable.email">
                  Veuillez entrer une adresse mail valide
                </div>
              </div>
              <v-combobox v-model="$v.responsable.$model" :items="responsablesList" label="Responsable"></v-combobox>
            </div>
            <v-textarea v-model="commentaires" label="Commentaires"></v-textarea>
            <v-text-field v-model="appui" label="Avec l'appui de"></v-text-field>
            <v-row>
              <v-col>
                <v-btn type="submit">Enregistrer</v-btn>
              </v-col>
              <v-col>
                <v-btn @click.stop="close">Fermer</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DatePickerComponent from "../Dialog/DatePickerComponent";
import { required, requiredIf, email, numeric } from "vuelidate/lib/validators";
export default {
  name: "ActiviteFormComponent",
  components: { DatePickerComponent },
  props: ["btn_text", "titre", "objectif_id", "activite_id", "edit"],
  data: () => ({
    dialog: false,
    activite: null,
    nomActivite: "",
    ordre: null,
    dateDebut: "",
    dateFin: "",
    etatEcheancier: "",
    avancement: "",
    responsable: "",
    responsablesList: null,
    appui: "",
    commentaires: "",
    etatEcheancierItems: ["Respecté", "Devancé", "Retard"],
    avancementItems: ["En cours", "En continu", "Non débuté", "Terminé"],
    modalDatePicker1: "",
    modalDatePicker2: "",
  }),
  validations: {
    nomActivite: {
      required,
    },
    ordre: {
      required: requiredIf(function () {
        return this.edit
      }),
      numeric
    },
    dateDebut: {
      required,
    },
    dateFin: {
      required,
    },
    etatEcheancier: {
      required,
    },
    avancement: {
      required,
    },
    responsable: {
      required,
      email,
    },
  },
  watch: {
    dialog(value) {
      if (value) {
        this.open();
      }
    },
  },
  methods: {
    ...mapActions(["addActivite", "updateActivite"]),
    ...mapGetters(["getActivite", "getResponsablesList"]),
    editLoadActivite() {
      var activite = this.activite;
      this.nomActivite = activite.nom_activite;
      this.ordre = activite.ordre;
      this.dateDebut = activite.date_debut;
      this.dateFin = activite.date_fin;
      this.etatEcheancier = activite.etat_echeancier;
      this.avancement = activite.avancement;
      this.responsable = activite.responsable;
      this.appui = activite.appui;
      this.commentaires = activite.commentaires;
    },
    saveForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (!this.$props.edit) {
          this.addNew();
        } else {
          this.update();
        }
        this.close();
      }
    },
    saveDateDebut(date) {
      this.dateDebut = date;
    },
    saveDateFin(date) {
      this.dateFin = date;
    },
    addNew() {
      var activite = {
        nom_activite: this.nomActivite,
        date_debut: this.dateDebut,
        date_fin: this.dateFin,
        etat_echeancier: this.etatEcheancier,
        avancement: this.avancement,
        responsable: this.responsable,
        appui: this.appui,
        commentaires: this.commentaires,
        objectif: this.$props.objectif_id,
      };
      this.addActivite(activite);
    },
    update() {
      this.activite.nom_activite = this.nomActivite;
      this.activite.date_debut = this.dateDebut;
      this.activite.date_fin = this.dateFin;
      this.activite.etat_echeancier = this.etatEcheancier;
      this.activite.ordre = this.ordre;
      this.activite.avancement = this.avancement;
      this.activite.responsable = this.responsable;
      this.activite.appui = this.appui;
      this.activite.commentaires = this.commentaires;
      this.updateActivite(this.activite);
    },
    resetForm() {
      this.nomActivite = null;
      this.ordre = null;
      this.dateDebut = null;
      this.dateFin = null;
      this.etatEcheancier = null;
      this.avancement = null;
      this.responsable = null;
      this.appui = null;
      this.commentaires = null;
    },
    close() {
      this.resetForm();
      this.$v.$reset();
      if (!this.edit) {
        this.dateDebut = "";
        this.dateFin = "";
      }
      this.dialog = false;
    },
    open() {
      this.resetForm();
      this.$v.$reset();
      this.responsablesList = this.getResponsablesList();
      if (this.$props.edit == true) {
        this.activite = this.getActivite()(this.activite_id);
        this.editLoadActivite();
      }
    },
  },
};
</script>